<template>
    <div class="main">
        <c-panel title="ALMOXARIFADO — RELATÓRIOS" titleIcon="fas fa-file-pdf">
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24">
                        <el-form-item label="Relatório">
                            <el-select v-model="tipo" @change="changeTipo" placeholder="Selecione o relatório" style="width:100%;">
                                <el-option v-for="r in relatorios" :key="r.value" :label="r.label" :value="r.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-if="tipo">
                    <el-col :xs="24" :sm="6" v-if="mostra('instituicao') && ehSmed">
                        <el-form-item label="Instituição">
                            <el-select v-model="filtro.instituicao_id" placeholder="Todas" filterable clearable style="width:100%;">
                                <el-option v-for="i in $store.state.instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" v-if="mostra('grupo')">
                        <el-form-item label="Grupo">
                            <el-select v-model="filtro.grupo_id" placeholder="Todos" filterable clearable style="width:100%;">
                                <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" v-if="mostra('produto')">
                        <el-form-item label="Produto">
                            <el-select v-model="filtro.produto_id" placeholder="Todos" filterable remote clearable :remote-method="buscarProduto" :loading="loadingProd" style="width:100%;">
                                <el-option v-for="p in produtos" :key="p.id" :label="`${p.codigo} — ${p.nome}`" :value="p.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" v-if="mostra('tipo')">
                        <el-form-item label="Tipo de movimento">
                            <el-select v-model="filtro.tipo" placeholder="Todos" clearable style="width:100%;">
                                <el-option v-for="t in tiposMov" :key="t.v" :label="t.l" :value="t.v"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" v-if="mostra('busca')">
                        <el-form-item label="Buscar produto (nome ou código)">
                            <el-input v-model="filtro.busca" placeholder="Pesquisar produto..." clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" v-if="mostra('periodo')" class="u-mt-10">
                        <el-form-item label="Período (data)">
                            <el-date-picker v-model="periodo" type="daterange" value-format="yyyy-MM-dd" format="dd/MM/yyyy" range-separator="até" start-placeholder="Início" end-placeholder="Fim" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" v-if="mostra('situacao')">
                        <el-form-item label="Situação">
                            <el-select v-model="filtro.situacao" placeholder="Todos" clearable style="width:100%;">
                                <el-option label="Ativos" :value="true"></el-option>
                                <el-option label="Inativos" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" style="padding-top: 30px;" v-if="mostra('zerados')">
                        <el-checkbox v-model="filtro.incluir_zerados">Incluir saldo zerado</el-checkbox>
                    </el-col>
                </el-row>

                <el-row class="u-mt-10">
                    <el-col :xs="24" class="u-text-right">
                        <el-button @click="gerar" type="primary" :disabled="!tipo"><i class="el-icon-printer"></i> GERAR PDF</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        tipo: '',
        grupos: [],
        produtos: [],
        loadingProd: false,
        periodo: [],
        tiposMov: [
            { v: 1, l: 'Entrada' }, { v: 2, l: 'Saída' },
            { v: 3, l: 'Transf. Saída' }, { v: 4, l: 'Transf. Entrada' }, { v: 5, l: 'Ajuste' }
        ],
        relatorios: [
            { value: 'produtos',      label: 'Produtos do almoxarifado (estoque e lote)', url: '/api/almox-relatorio/produtos',      filtros: ['instituicao', 'grupo', 'busca', 'zerados'] },
            { value: 'abaixo-minimo', label: 'Produtos abaixo do estoque mínimo',         url: '/api/almox-relatorio/abaixo-minimo', filtros: ['instituicao', 'grupo', 'busca'] },
            { value: 'fornecedores',  label: 'Fornecedores',                              url: '/api/almox-relatorio/fornecedores',  filtros: ['situacao'] },
            { value: 'movimentacoes', label: 'Movimentações',                             url: '/api/almox-relatorio/movimentacoes', filtros: ['instituicao', 'produto', 'tipo', 'periodo'] }
        ],
        filtro: {
            instituicao_id: '', grupo_id: '', busca: '', incluir_zerados: false,
            situacao: '', produto_id: '', tipo: ''
        }
    }),
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        config () { return this.relatorios.find(r => r.value === this.tipo) || { filtros: [] } }
    },
    mounted () {
        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }
        this.carregarGrupos()
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        mostra (campo) { return this.config.filtros.indexOf(campo) !== -1 },
        changeTipo () {
            // limpa filtros específicos ao trocar de relatório
            this.filtro.grupo_id = ''
            this.filtro.busca = ''
            this.filtro.produto_id = ''
            this.filtro.tipo = ''
            this.filtro.situacao = ''
            this.filtro.incluir_zerados = false
            this.periodo = []
        },
        carregarGrupos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-grupo/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.grupos = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        buscarProduto (q) {
            if (!q || q.length < 2) return
            this.loadingProd = true
            this.$axios.post(`${this.baseUrl()}/api/almox-produto/getAllPaginate`, { busca: q, situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.produtos = (r.data && r.data.data) ? r.data.data : []; this.loadingProd = false })
                .catch(() => { this.loadingProd = false })
        },
        gerar () {
            const rep = this.config
            const param = {}
            if (this.mostra('instituicao')) param.instituicao_id = this.filtro.instituicao_id || ''
            if (this.mostra('grupo')) param.grupo_id = this.filtro.grupo_id || ''
            if (this.mostra('busca')) param.busca = this.filtro.busca || ''
            if (this.mostra('zerados')) param.incluir_zerados = this.filtro.incluir_zerados ? 1 : ''
            if (this.mostra('situacao')) param.situacao = this.filtro.situacao
            if (this.mostra('produto')) param.produto_id = this.filtro.produto_id || ''
            if (this.mostra('tipo')) param.tipo = this.filtro.tipo || ''
            if (this.mostra('periodo')) {
                param.data_inicio = (this.periodo && this.periodo[0]) || ''
                param.data_fim = (this.periodo && this.periodo[1]) || ''
            }
            window.eventBus.$emit('print', { url: rep.url, param: param })
        }
    }
}
</script>
